// @flow
import * as React from 'react';
import { Button, Result } from 'antd';
import './notfind.scss';
type Props = {};
export const NotFInd = (props: Props) => {
  return (
    <div className="notfind">
      `{' '}
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={<Button type="primary">Back Home</Button>}
      />
    </div>
  );
};
